"use client";
import React, { useEffect, useRef, useState } from "react";


type Props = {
  children: React.ReactNode;
  rootMargin?: string;
  threshold?: number | number[];
  className?: string;
  style?: React.CSSProperties;
};

export default function AnimateOnView({
  children,
  rootMargin = "0px",
  threshold = 0.2,
  className,
  style,
}: Props) {
  const ref = useRef<HTMLDivElement | null>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!ref.current || visible) return;
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setVisible(true);
            obs.disconnect();
          }
        });
      },
      { root: null, rootMargin, threshold },
    );
    obs.observe(ref.current);
    return () => obs.disconnect();
  }, [rootMargin, threshold, visible]);

  return (
    <div
      ref={ref}
      className={className}
      style={{
        transform: visible ? "translateY(0)" : "translateY(24px)",
        opacity: visible ? 1 : 0,
        transition:
          "transform 600ms cubic-bezier(.2,.8,.2,1), opacity 600ms ease",
        willChange: "transform, opacity",
        ...style,
      }}
    >
      {children}
    </div>
  );
}
